(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kyron-hero-3d"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kyron-hero-3d')){
 class KyronHero3D extends HTMLElement{
  connectedCallback(){
   if(this.started)return;
   this.started=true;
   this.abort=new AbortController();
   this.viewer=this.querySelector('model-viewer');
   this.hero=this.closest('.k-hero');
   this.hint=this.querySelector('.k3d-hint');
   this.footer=this.querySelector('.k3d-footer');
   this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
   this.fine=matchMedia('(hover: hover) and (pointer: fine)');
   this.manual=false;this.inView=true;this.frame=0;this.hoverX=0;this.hoverY=0;
   this.fallback=false;
   const on=(el,type,fn,options={})=>el.addEventListener(type,fn,{...options,signal:this.abort.signal});
   on(this.viewer,'load',()=>{
    this.classList.add('is-ready');this.dataset.renderMode='3d';this.footer.hidden=false;this.ready=true;
    this.queue();
   });
   on(this.viewer,'error',()=>{
    this.classList.remove('is-ready');this.dataset.renderMode='image';this.footer.hidden=true;this.fallback=true;this.ready=true;this.manual=false;this.queue();
   });
   on(window,'scroll',()=>this.queue(),{passive:true});
   on(window,'resize',()=>this.queue(),{passive:true});
   on(this.reduced,'change',()=>{this.hoverX=0;this.hoverY=0;this.queue();});
   on(this.viewer,'pointerdown',e=>{
    this.down={x:e.clientX,y:e.clientY};
    if(e.pointerType==='mouse')this.takeControl();
   },{passive:true});
   on(this.viewer,'pointermove',e=>{
    if(e.pointerType==='touch'&&this.down){
     const dx=Math.abs(e.clientX-this.down.x),dy=Math.abs(e.clientY-this.down.y);
     if(dx>8&&dx>dy)this.takeControl();
    }
    if(this.manual||this.reduced.matches||!this.fine.matches||e.buttons)return;
    const r=this.viewer.getBoundingClientRect();
    this.hoverX=((e.clientX-r.left)/r.width-.5)*2;
    this.hoverY=((e.clientY-r.top)/r.height-.5)*2;this.queue();
   },{passive:true});
   on(this.viewer,'pointerleave',()=>{this.down=null;this.hoverX=0;this.hoverY=0;this.queue();});
   for(const event of ['pointerup','pointercancel'])on(this.viewer,event,()=>{this.down=null;});
   on(this.viewer,'keydown',e=>{if(['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key))this.takeControl();});
   this.querySelectorAll('[data-angle]').forEach(button=>on(button,'click',()=>{
    this.manual=true;
    const angle=button.dataset.angle,positions={front:'0deg 77deg 105%',top:'0deg 10deg 105%',bottom:'18deg 151deg 105%'};
    this.viewer.setAttribute('camera-orbit',positions[angle]);
    this.markAngle(angle);this.hint.textContent=this.dataset.manual;
    if(this.reduced.matches&&this.viewer.jumpCameraToGoal)this.viewer.jumpCameraToGoal();
   }));
   on(this.querySelector('[data-reset]'),'click',()=>{
    this.manual=false;this.hoverX=0;this.hoverY=0;this.markAngle('front');
    this.hint.textContent=this.dataset.hint;this.queue();
   });
   this.observer=new IntersectionObserver(entries=>{
    this.inView=entries[0].isIntersecting;if(this.inView)this.queue();
   },{rootMargin:'80px'});this.observer.observe(this.hero);
   try{
    const probe=document.createElement('canvas');
    const context=probe.getContext('webgl2')||probe.getContext('webgl');
    if(!context)throw new Error('WebGL unavailable');
    context.getExtension('WEBGL_lose_context')?.loseContext();
   }catch(error){this.dataset.renderMode='image';this.fallback=true;this.ready=true;this.queue();return;}
   if(customElements.get('model-viewer'))return;
   if(window.Shopify&&typeof Shopify.loadFeatures==='function'){
    Shopify.loadFeatures([{name:'model-viewer',version:'1.12',onLoad:errors=>{
     if(errors){this.footer.hidden=true;return;}
     customElements.whenDefined('model-viewer').then(()=>{if(this.viewer.loaded){this.classList.add('is-ready');this.ready=true;this.footer.hidden=false;this.queue();}});
    }}]);
   }
  }
  markAngle(angle){this.querySelectorAll('[data-angle]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.angle===angle)));}
  takeControl(){if(this.fallback)return;if(!this.manual){this.manual=true;this.hint.textContent=this.dataset.manual;this.markAngle('');}}
  queue(){
   if(!this.ready||this.manual||!this.inView||document.hidden||this.frame)return;
   this.frame=requestAnimationFrame(()=>{
    this.frame=0;
    if(this.manual||!this.inView||!this.isConnected)return;
    const rect=this.hero.getBoundingClientRect();
    const progress=Math.max(0,Math.min(1,-rect.top/Math.max(rect.height,1)));
    const theta=this.reduced.matches?22:22+progress*52+this.hoverX*7;
    const phi=this.reduced.matches?72:72-progress*18+this.hoverY*4;
    if(this.fallback){
     const x=this.reduced.matches?0:this.hoverX*5;
     const y=this.reduced.matches?0:-progress*10+this.hoverY*3;
     this.querySelector('.k3d-poster').style.transform=`translate3d(${x}px,${y}px,0)`;
     return;
    }
    this.viewer.setAttribute('camera-orbit',`${theta.toFixed(2)}deg ${phi.toFixed(2)}deg 105%`);
    if(this.reduced.matches&&this.viewer.jumpCameraToGoal)this.viewer.jumpCameraToGoal();
   });
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.started=false;}
 }
 customElements.define('kyron-hero-3d',KyronHero3D);
}
  } catch(e) { console.error(e); }
})();

})();
